import { ExperimentEnum } from '@/types';
import { useExperiment } from '@statsig/react-bindings';

export function useDashboardSegmentationExperiment() {
  const experiment = useExperiment(ExperimentEnum.DASHBOARD_SEGMENTATION);

  return {
    enabled: !!experiment.value.enabled,
    experimentGroup: experiment.groupName,
    brickTitle: (experiment.value.brickTitle as string) || null,
    brickSubtitle: (experiment.value.brickSubtitle as string) || null,
    brickCta: (experiment.value.brickCta as string) || null
  };
}
